import React from 'react';
import styles from '../../styles.module.scss'
import { useVendorPointSolutionContext } from '../vendor-solution-provider';

const OrganizationSelectedList = () => {
  const {
    selectedListOrg,
    setSelectedListOrg
  } = useVendorPointSolutionContext();

  const handleDeleteSelectedOrg = org => {
    const updatedSelectedListOrg = selectedListOrg.filter(item => item.organization_id !== org.organization_id)
    setSelectedListOrg(updatedSelectedListOrg)
  }

  return (
    <div className={styles.vendorPointListContainer}>
      <div className={styles.vendorPointBox}>
        <div className={styles.box}>
          <div>
            <h3 className={styles.headerTitleBox}>Selected Groups</h3>
          </div>
          <table>
            <tbody>
            {selectedListOrg.map(org =>
              <tr key={`selected-vendor-point-${org.organization_id}`}>
                <td>{org.organization_nm}</td>
                <td>
                  <a onClick={() => handleDeleteSelectedOrg(org)}>Delete</a>
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default OrganizationSelectedList;
